import { LoginFieldPresenter } from '@/forms/components/presenters/LoginFieldPresenter';
import {
  FormFieldType,
  type LoginFormField,
  type SingleFormField,
} from '@/forms/typings';

import type { FormFieldModule } from '../registry/field-module.types';

import { buildLoginInitialState } from './initialState';

export const loginFieldModule: FormFieldModule = {
  type: FormFieldType.Login,
  Presenter: ({ field }) => (
    <LoginFieldPresenter field={field as LoginFormField} />
  ),
  flattenLeaves: field => [(field as LoginFormField).field as SingleFormField],
  buildInitialState: buildLoginInitialState,
};
